const n = "median", c = "mean", t = "max", o = "min", N = "count", E = "cardinality", s = "range", a = "label_name", e = "label_numeric", A = "any", L = "Unknown", I = "percent", R = "value";
export {
  E as CARDINALITY,
  N as COUNT,
  t as MAX,
  c as MEAN,
  n as MEDIAN,
  o as MIN,
  I as PERCENT,
  s as RANGE,
  A as REPORTING_FILTER_SELECT_ALL,
  a as SORTING_LABEL_NAME,
  e as SORTING_LABEL_NUMERIC,
  L as UNKNOWN,
  R as VALUE
};
